import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PrivacyPolicyPage.css';
import Header from '../components/Header';

function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="privacy-container">
      <Header />
      <div className="privacy-card">
        <button className="back-button" onClick={() => navigate('/')}>
          ← Back to Home
        </button>

        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-subtitle">
          Last updated: January 15, 2026
        </p>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2>Introduction</h2>
            <p>
              Welcome to Who Is Most Likely ("we," "our," or "us"). We respect your privacy and are 
              committed to protecting your personal data. This privacy policy explains how we collect, 
              use, and safeguard your information when you use our mobile application and website.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Information We Collect</h2>
            <h3>Account Information</h3>
            <p>
              When you create an account, we collect your <strong>email address</strong> and 
              <strong> display name</strong>. This information is used solely for:
            </p>
            <ul>
              <li>Account authentication and login</li>
              <li>Identifying you within the game to other players</li>
              <li>Communicating important updates about your account</li>
            </ul>

            <h3>Usage Data</h3>
            <p>
              We collect anonymous usage data through Aptabase, a privacy-focused analytics service. 
              This includes:
            </p>
            <ul>
              <li>App usage patterns (e.g., features used, screens visited)</li>
              <li>Game statistics (e.g., game modes played, session duration)</li>
              <li>Technical information (e.g., device type, app version)</li>
            </ul>
            <p>
              This data is collected anonymously and cannot be used to personally identify you. 
              We use this information to improve our app and understand how users interact with our features.
            </p>
          </section>

          <section className="privacy-section">
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and maintain our service</li>
              <li>Allow you to participate in games with other players</li>
              <li>Improve and optimize our application</li>
              <li>Communicate with you about your account or service updates</li>
              <li>Detect and prevent fraud or abuse</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Data Sharing</h2>
            <p>
              We do <strong>not</strong> sell, trade, or rent your personal information to third parties. 
              Your data may be shared only in the following circumstances:
            </p>
            <ul>
              <li><strong>With other players:</strong> Your display name is visible to other players in your game session</li>
              <li><strong>Service providers:</strong> We use Firebase for authentication and data storage, and Aptabase for analytics</li>
              <li><strong>Legal requirements:</strong> If required by law or to protect our rights</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information. 
              Your data is stored securely using Firebase, which employs industry-standard 
              encryption and security practices.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Update or correct your information</li>
              <li>Delete your account and associated data</li>
              <li>Opt out of non-essential communications</li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at{' '}
              <a href="mailto:whoismostlikely@gmail.com">whoismostlikely@gmail.com</a>.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Children's Privacy</h2>
            <p>
              Our service is not intended for children under the age of 13. We do not knowingly 
              collect personal information from children under 13. If you believe we have collected 
              information from a child under 13, please contact us immediately.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. We will notify you of any 
              significant changes by posting the new policy on this page and updating the 
              "Last updated" date.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this privacy policy or our data practices, 
              please contact us at:
            </p>
            <div className="contact-box">
              <p><strong>Email:</strong> <a href="mailto:whoismostlikely@gmail.com">whoismostlikely@gmail.com</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
